import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=02976404&scoped=true&lang=pug&"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=02976404&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02976404",
  null
  
)

export default component.exports